module.exports = __webpack_public_path__ + "static/img/lmzh@2x.fae1b0f6.png";